import React, {useState} from "react";
import {inject, observer} from "mobx-react";

import {LLBtn, llNotifier} from "../../elements";
import {getCookie, removeCookie, setCookie, trans} from "../../../common/utils";
import {DrawerCloseButton} from "../../../pages/user-profile/components";
import config from "../../../static/themes/config";
import SignUpPartOne from "./components/sign-up-part-one";
import SignUpPartTwo from "./components/sign-up-part-two";
import SignUpForbidden from "./components/sign-up-forbiden";


const commonInputProps = {
    labelPosition: 'inside',
    showClearButton: true,
    stylingMode: 'outlined',
};

const SimpleSignUpForm = (
    {store}
) => {
    const viewSize = store.site.status.viewSize,
        btag = store.user.btag,
        simpleSignup = store.user.simpleSignup,
        simpleSignupCode = store.user.simpleSignupCode,
        openLogin = store.user.openLogin,
        drawer = store.drawer;

    const [formPart, setFormPart] = useState(getCookie('signup-forbidden') ? 0 : 1),
        [isSubmitFetching, setSubmitFetching] = useState(false),
        [smsTimer, setSmsTimer] = useState(null),
        [canGetNewOne, setGetNewOne] = useState(false),
        [errors, setErrors] = useState({
            username: '',
            phone: '',
            code: ''
        }),
        [form, setForm] = useState({
            username: '',
            phone: '',
            code: ''
        });

    const signUpSubmit = (getSMS = false) => {
        setSubmitFetching(true);

        const data = {
            username: form.username,
            phone: form.phone,
        };
        if (btag) data.btag = btag;

        if (formPart === 2 && !getSMS) {
            data.code = form.code;

            simpleSignupCode({...data}).then((response) => {
                if (!response?.success) {
                    if (response.data.attempts_available >= 3) {
                        llNotifier({
                            message:
                                'You entered the wrong code three times. A new code has been sent to you via SMS.',
                            type: 'error',
                        });
                        setForm({
                            ...form,
                            code: '',
                        });
                    }
                    if (response?.data?.error) {
                        llNotifier({
                            message: response?.data?.error || 'GENERAL_ERROR',
                            type: 'error',
                        });
                        if (response?.data?.error === 'ATTEMPTS_LIMIT_EXHAUSTED') {
                            drawer.close();
                        }
                        if (response?.data?.error === 'WRONG_CODE') {
                            setErrors((v) => ({
                                ...v,
                                code: response?.data?.error,
                            }))
                        }
                    }
                } else {
                    if (config.scripts && config.scripts.signupScript) {
                        const range = document.createRange();
                        document.head.appendChild(
                            range.createContextualFragment(
                                config.scripts.signupScript
                            )
                        );
                    }
                    llNotifier({
                        message:
                            'Registration successful! Your password will be sent to you by SMS.',
                        type: 'success',
                    });
                    drawer.close();
                }
                setSubmitFetching(false);
            });
            return;
        }

        simpleSignup({...data}).then((response) => {
            if (!response?.success) {
                if (response?.data?.description) {
                    const errorKeys = Object.keys(response.data.description);
                    if (errorKeys?.length) {
                        errorKeys.forEach((key) => {
                            if (errors[key] || errors[key] === '') {
                                setErrors((v) => ({
                                    ...v,
                                    [key]: response.data.description[key],
                                }))
                            }
                        });
                    }
                    llNotifier({
                        message: response.data.description[errorKeys[0]],
                        type: 'error',
                    });
                } else if (response?.data?.error) {
                    llNotifier({
                        message: response?.data?.error,
                        type: 'error',
                    });
                    if (response?.data?.error === 'PHONE_ALREADY_USED') {
                        setErrors((v) => ({
                            ...v,
                            phone: response?.data?.error,
                        }))
                    }
                    if (response?.data?.error === 'REGISTRATION_BLOCKED') {
                        setCookie('signup-forbidden', response?.data?.block_time);
                        setFormPart(0);
                    }
                    if (response?.data?.error === 'CODE_ALREADY_SENT') {
                        setSmsTimer(response?.data?.timeout);
                        setFormPart(2);
                    }
                }
            } else {
                removeCookie('signup-forbidden');
                setSmsTimer(null);
                setGetNewOne(false);
                setFormPart(2);
                llNotifier({
                    message:
                        'We`ve sent the code to your phone via SMS.',
                    type: 'success',
                });
            }
            setSubmitFetching(false);
        });
    }

    const currentPart = () => {
        const parts = {
            0: <SignUpForbidden setFormPart={setFormPart}/>,
            1: <SignUpPartOne commonInputProps={commonInputProps} form={form} setForm={setForm} errors={errors}
                              setErrors={setErrors}
               />,
            2: <SignUpPartTwo commonInputProps={commonInputProps} form={form} setForm={setForm} errors={errors}
                              setErrors={setErrors} signUpSubmit={signUpSubmit} smsTimer={smsTimer}
                              canGetNewOne={canGetNewOne}
                              setGetNewOne={setGetNewOne}
               />,
        }
        return parts[formPart]
    }

    return (
        <div className={`simple-signup signup--${viewSize}`}>
            {viewSize === "desktop" ? (
                <div className="signup-drawer__header">
                    <p>{trans('Registration form')}</p>
                    <DrawerCloseButton/>
                </div>) : null}

            <div className="signup__container">
                <div className="signup__form">
                    <div className={`${viewSize !== "mobile" ? 'signup__form-header' : 'signup__header--mobile'}`}>
                        {trans('Account info')}
                        {viewSize !== "desktop" && (<DrawerCloseButton/>)}
                    </div>
                    {currentPart()}
                    <div className="signup__footer">
                        {formPart !== 0 && <LLBtn
                            className={`signup__sumbit-btn signup__submit ll-btn--accent`}
                            useSubmitBehavior={false}
                            disabled={isSubmitFetching
                                || form.username.length < 3
                                || !(/.*^[a-zA-Z0-9]+$.*/.test(form.username))
                                || form.phone.length < 10
                                || (formPart === 2 && form.code.length < 4)
                                || !!errors.username
                                || !!errors.phone
                                || !!errors.code}
                            onClick={() => {
                                if (!isSubmitFetching) {
                                    signUpSubmit();
                                }
                            }}
                                           >
                            <div>
                                <span>{trans('Submit')}</span>
                            </div>
                        </LLBtn>}
                    </div>
                    <div className="signup__login">
                        <span>{trans('ALREADY_ACCOUNT')}</span>
                        <span
                            className="signup__login-btn"
                            onClick={() => {
                                drawer.close();
                                openLogin();
                            }}
                        >{trans('Login here')}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default inject('store')(observer(SimpleSignUpForm));